import moment from 'moment';

/**
 * Luật THÔNG BÁO TỚI LƯỢT (dùng ở mọi trang, ↔ app `instant_auto_popup.dart tinhThongBaoToiLuot`):
 *  - một lượt "đang tới" khi now ∈ [start_time, start_time + reserved_time) — đúng điều kiện của
 *    processCountDownForInstant (InstantOrderV2.tsx);
 *  - khóa mỗi lượt = `owner_id|start_time`: bấm X thì bỏ qua MỌI khóa đang hiện; lượt mới của cùng đơn
 *    (start_time khác) là khóa mới nên thông báo lại; thông báo chỉ hiện khi có ít nhất một khóa đang
 *    tới mà chưa bị bỏ qua, và liệt kê TẤT CẢ lượt đang tới.
 */
export interface LuotCuaToi {
  owner_id: string;
  order_id: string;
  start_time: string;
  reserved_time: number;
  deliver_route?: string;
}

export interface LuotDangToi extends LuotCuaToi {
  khoa: string;
  phut: number;
}

/** Khóa localStorage (dùng chung MỌI tab trình duyệt) — "ĐÓNG Ở TẤT CẢ TAB"; sự kiện `storage` báo sang tab khác. */
export const KHOA_BO_QUA_TOI_LUOT = 'luot-van-hanh-bo-qua';
/** Khóa sessionStorage (riêng TAB này, sống qua tải lại trang) — "ĐÓNG THÔNG BÁO TAB NÀY". */
export const KHOA_BO_QUA_TOI_LUOT_TAB = 'luot-van-hanh-bo-qua-tab';

export const khoaLuot = (luot: LuotCuaToi): string => `${luot.owner_id}|${luot.start_time}`;

export const nhanPhut = (reservedTime: number): number => Math.max(1, Math.round(Number(reservedTime) / 60));

export function tinhThongBaoToiLuot(
  luots: LuotCuaToi[],
  now: moment.Moment,
  daBoQua: string[],
): { dangToiLuot: LuotDangToi[]; coKhoaMoi: boolean } {
  const dangToiLuot: LuotDangToi[] = [];
  for (const luot of luots || []) {
    const batDau = moment(luot.start_time);
    if (!batDau.isValid() || !(Number(luot.reserved_time) > 0)) {
      continue;
    }
    if (now.isBetween(batDau, batDau.clone().add(Number(luot.reserved_time), 'seconds'))) {
      dangToiLuot.push({ ...luot, khoa: khoaLuot(luot), phut: nhanPhut(luot.reserved_time) });
    }
  }
  const coKhoaMoi = dangToiLuot.some((it) => !daBoQua.includes(it.khoa));
  return { dangToiLuot, coKhoaMoi };
}

function locKhoaConMoi(raw: any): string[] {
  if (!Array.isArray(raw)) {
    return [];
  }
  const mocCu = moment().subtract(1, 'day');
  return raw.filter((khoa: any) => {
    if (typeof khoa !== 'string') {
      return false;
    }
    const startTime = khoa.split('|')[1];
    return startTime && moment(startTime).isAfter(mocCu);
  });
}

/** Khóa đã bỏ qua RIÊNG TAB NÀY (sessionStorage). */
export function docDaBoQuaTab(): string[] {
  try {
    return locKhoaConMoi(JSON.parse(sessionStorage.getItem(KHOA_BO_QUA_TOI_LUOT_TAB) || '[]'));
  } catch (e) {
    return [];
  }
}

export function ghiDaBoQuaTab(khoas: string[]) {
  try {
    sessionStorage.setItem(
      KHOA_BO_QUA_TOI_LUOT_TAB,
      JSON.stringify(Array.from(new Set([...docDaBoQuaTab(), ...khoas]))),
    );
  } catch (e) {
    // sessionStorage bị chặn thì chỉ nhớ trong bộ nhớ (component giữ ref)
  }
}

/** Đọc danh sách khóa đã bỏ qua Ở MỌI TAB (localStorage), bỏ khóa có start_time cũ hơn 1 ngày để không phình. */
export function docDaBoQua(): string[] {
  try {
    const raw = JSON.parse(localStorage.getItem(KHOA_BO_QUA_TOI_LUOT) || '[]');
    return locKhoaConMoi(raw);
  } catch (e) {
    return [];
  }
}

export function ghiDaBoQua(khoas: string[]) {
  try {
    const hienCo = docDaBoQua();
    localStorage.setItem(KHOA_BO_QUA_TOI_LUOT, JSON.stringify(Array.from(new Set([...hienCo, ...khoas]))));
  } catch (e) {
    // localStorage bị chặn thì chỉ mất trí nhớ bỏ qua sau khi tải lại trang
  }
}
